// fw CheckRow — one work-list item a crew ticks off.
//
// A 48px row with a 26px box; the check glyph is drawn in CSS, not a
// character, so there is nothing for noEmojiUi.test.js to object to and
// nothing that depends on a font. role="checkbox" + aria-checked, toggled by
// click, Space or Enter. Disabled rows announce aria-disabled and ignore all
// three.

import React from 'react';
import './CheckRow.css';

export function CheckRow({ checked = false, label, onToggle, disabled = false, meta, className = '', ...rest }) {
  const fire = () => {
    if (disabled) return;
    if (onToggle) onToggle(!checked);
  };
  const onKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
      e.preventDefault();
      fire();
    }
  };
  return (
    <div
      className={['fw-checkrow', checked ? 'fw-checkrow--done' : '', disabled ? 'fw-checkrow--disabled' : '', className].filter(Boolean).join(' ')}
      role="checkbox"
      aria-checked={checked ? 'true' : 'false'}
      aria-disabled={disabled ? 'true' : undefined}
      tabIndex={disabled ? -1 : 0}
      onClick={fire}
      onKeyDown={onKeyDown}
      {...rest}
    >
      <span className="fw-checkrow__box" aria-hidden="true" />
      <span className="fw-checkrow__text">
        <span className="fw-checkrow__label">{label}</span>
        {meta ? <span className="fw-checkrow__meta">{meta}</span> : null}
      </span>
    </div>
  );
}

export default CheckRow;
